import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {useEditor} from "../../../../../../App.jsx";
import {useProyecto} from "../../../../Profile.jsx";
import {
    IconEdit, IconPhoto,
    IconPlus,
    IconProject,
    IconUser
} from "../../../../../Customiz3r/components/ToolSelectorTop/Icons.jsx";
import HoverImageIcon from "./ItemPresupuestoEditor/HoverImageIcon.jsx";
import {useNavigate} from "react-router-dom";
import {editorPathForId} from "../../../../../../products/registry";

const PresupuestoViewer = () => {
    const [presupuesto, setPresupuesto] = useState(null);
    const {proyecto, setProyecto} = useProyecto();
    const [showItemEditor, setShowItemEditor] = useState(false); // Estado para controlar el editor de ítems
    const [selectedItemId, setSelectedItemId] = useState(null); // Para identificar el ítem a editar

    const {stateEditor, setStateEditor} = useEditor();

    useEffect(() => {
        if (stateEditor?.editorID) {
            // Cargar los datos del presupuesto
            axios.get(`/presupuestos/${stateEditor?.editorID}/`)
                .then(response => {
                    setPresupuesto(response.data);
                    console.log('Presupuesto:', response.data);
                })
                .catch(error => {
                    console.error('Error al cargar el presupuesto:', error);
                });
        }
    }, [stateEditor?.editorID]);

    const handleEdit = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: stateEditor?.editorID,
            editorType: "presupuesto_editor"
        });
    };

    const handleAddItem = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: "add",
            editorType: "item_presupuesto_editor"
        });

    };

    const handleEditItem = (itemId) => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: itemId,
            editorType: "item_presupuesto_editor"
        });
        // setProyecto(proyecto);
    };

    const navigate = useNavigate();

    const handleEditCustomizedKeyring = (itemId) => {
        navigate(editorPathForId(itemId));
    }

    const handleCloseItemEditor = () => {
        setShowItemEditor(false); // Cerrar el editor de ítems
        setSelectedItemId(null); // Resetear el ítem seleccionado
        // Aquí podrías recargar la lista de ítems si lo deseas
        // axios.get(`/presupuestos/${id}/`).then(response => setPresupuesto(response.data));
    };

    return (
        <div className="h-full mx-auto p-6 pt-2 bg-white text-gray-800 dark:bg-gray-800 dark:text-white">
            {presupuesto ? (
                <>
                    <div className="absolute top-3 right-2 flex space-x-3">
                        <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                            onClick={handleEdit}
                            aria-label="Edit Presupuesto"
                            type="button"
                        >
                            <div className="flex items-center">
                                <IconEdit className="w-5 h-5"/>
                                <span className="ml-2">Editar Presupuesto</span>
                            </div>
                        </button>
                        <button
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                            onClick={() => {
                                setStateEditor({
                                    ...stateEditor,
                                    editorType: "cliente_view",
                                    editorID: proyecto.cliente,
                                    editor: true
                                });
                            }}
                            aria-label="Go back"
                        >
                            <div className="flex items-center">
                                <IconUser className="w-5 h-5"/>
                                <span className="ml-2">Cliente</span>
                            </div>
                        </button>
                        <button
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                            onClick={() => {
                                setStateEditor({
                                    ...stateEditor,
                                    editorType: "proyecto_viewer",
                                    editorID: proyecto.id,
                                    editor: true
                                });
                            }}
                            aria-label="Go back"
                        >
                            <div className="flex items-center">
                                <IconProject className="w-6 h-6"/>
                                <span className="ml-2">Proyecto</span>
                            </div>
                        </button>
                    </div>
                    <h2 className='text-3xl mb-4'>Presupuesto del Proyecto: {presupuesto.proyecto.nombre}</h2>

                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Detalles del Presupuesto</h2>
                        <p><strong>Descripción:</strong> {presupuesto.descripcion}</p>
                        <p><strong>Fecha de Creación:</strong> {presupuesto.fecha_creacion}</p>
                        <p><strong>Estado:</strong> {presupuesto.estado}</p>
                    </div>

                    {/* Tabla de ítems */}
                    <div className="mb-4">
                        <div className="grid grid-cols-5 gap-4">
                            <div className="col-span-3">
                                <h2 className="text-lg font-bold mb-2 w-full">
                                    Ítems del Presupuesto
                                </h2>
                            </div>
                            <div className="col-start-4 col-span-2 grid">
                                <button
                                    onClick={handleAddItem}
                                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    type="button"
                                >
                                    Añadir Ítem
                                </button>
                            </div>
                        </div>

                        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
                            <thead>
                            <tr className="bg-gray-100 dark:bg-gray-700">
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">#</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Producto</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Unidades</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Precio por Unidad</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Descuento</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Total</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {presupuesto.items.map((item, index) => (
                                <tr key={item.id} className="hover:bg-gray-50 dark:hover:bg-gray-600 transition duration-150 ease-in-out">
                                    <td className="py-2 px-4 border-b dark:border-gray-700">{index + 1}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300 w-fit">
                                        <div className="flex items-center">
                                            {item.keyring_model?.name }
                                            <HoverImageIcon
                                                icon={<IconEdit className="w-5 h-5" />}
                                                svg_2d={item.keyring_model?.svg_2d}
                                            />
                                        </div>

                                    </td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.unidades}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.precio_por_unidad}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.descuento_valor_fijo}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.precio_total}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700">

                                        <button
                                            className="bg-blue-500 text-white py-1 px-3 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700"
                                            onClick={() => handleEditItem(item.id)}
                                        >
                                            <IconEdit className="w-5 h-5" />
                                        </button>

                                        <button
                                            className="bg-blue-500 text-white py-1 px-3 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700"
                                            onClick={() => handleEditCustomizedKeyring(item.keyring_model.id)}
                                        >
                                            <IconEdit className="w-5 h-5" /> Objeto3D
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex items-center justify-between">
                        <button
                            onClick={() => setStateEditor({
                                ...stateEditor,
                                editor: false,
                            })} // Cierra el visualizador
                            className="bg-transparent hover:bg-gray-500 text-gray-700 dark:text-gray-300 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded"
                            type="button"
                        >
                            Cerrar
                        </button>
                    </div>

                </>
            ) : (
                <p>Cargando información del presupuesto...</p>
            )}
        </div>
    );
};

export default PresupuestoViewer;
